/**
 *
 * Header
 *
 */
import { Box, Image } from '@chakra-ui/react';
import { useState } from 'react';
import { StorageManager } from '@storage/index';
import { styles } from './styles';
import { Drawer } from './components/Drawer';
import { Module } from '@models/Module';
import { User, UserType } from '@models/User';
import { ProfileUser } from './components/ProfileUser';
import { ProfileAdmin } from './components/ProfileAdmin';
import { ButtonMenu } from './components/ButtonMenu';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'src/config/routes';

const Header = () => {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);
	const session = new StorageManager('session');
	const moduleStorage = session.getItem<Module>('selectedModule');
	const user = session.getItem<User>('user');
	const courseModules = session.getItem<Module[]>('courseModules');

	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	return (
		<Box>
			<Box sx={styles.headerGradient}>
				<Box sx={styles.headerImage}>
					<Box sx={styles.containerTitles}>
						<Box display="flex" alignItems="center">
							{user?.ENTRARCOMO === UserType.ALUNO && moduleStorage?.MODULO && (
								<ButtonMenu handleToggle={handleToggle} />
							)}
							{user?.ENTRARCOMO === UserType.PROFESSOR && <ButtonMenu handleToggle={handleToggle} />}
							<Image
								src="/images/header-logo.svg"
								alt="logo-afya"
								w="135px"
								display={{ base: 'none', sm: 'block' }}
								onClick={() => {
									user?.ENTRARCOMO === UserType.PROFESSOR ? navigate(ROUTES.homeTeacher) : navigate(ROUTES.homeStudent);
								}}
							/>
						</Box>
						{user?.ENTRARCOMO === UserType.ALUNO && (
							<ProfileUser courseModules={courseModules} moduleStorage={moduleStorage} user={user} />
						)}
						{user?.ENTRARCOMO === UserType.PROFESSOR && <ProfileAdmin user={user} />}
					</Box>
				</Box>
			</Box>
			<Box>
				{user?.ENTRARCOMO === UserType.ALUNO && moduleStorage?.MODULO && (
					<Drawer handleToggle={handleToggle} isOpen={isOpen} key={1} user={user} />
				)}
				{user?.ENTRARCOMO === UserType.PROFESSOR && (
					<Drawer handleToggle={handleToggle} isOpen={isOpen} key={2} user={user} />
				)}
			</Box>
		</Box>
	);
};

export { Header };
